import React from "react";
import { AuthContext } from "../../lib/AuthContext";
import ParentComponent from "../../lib/ParentComponent";
import firebase from "../../lib/firebase";
import Utils from "../../Utils";
import { NavLink } from "react-router-dom";
import ar from "../../locale";
import { title } from "../../constants";
import Loading from "../../lib/Loading";
import PhotoUploader from "../../lib/PhotoUploader";
import VideoUploader from "../../lib/VideoUploader";

export default class EgyptianVarEdit extends ParentComponent {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: context.user,
      loading: false,
      poll: {},
      upload: "image",
      pageloading: true,
      options: [
        { name: "", votes: 0, color: Utils.getRandomColor() },
        { name: "", votes: 0, color: Utils.getRandomColor() },
      ],
    };
    this.path = "polls/var/" + this.props.match.params.key;
    this.pollsRef = firebase.database().ref(this.path);
  }

  componentDidMount() {
    super.componentDidMount();
    document.title = title + " - " + ar.egy_var;
    this.pollsRef.on("value", (snapshot) => {
      if (!snapshot.exists()) {
        this.props.history.replace("/404");
      } else {
        this.state.poll = snapshot.val();
        this.state.options = this.state.poll.options;
        //this.state.media = this.state.poll.image;
        if (this.state.poll.video) {
          this.state.upload = "video";
          //this.state.media = this.state.poll.video;
        }
        this.state.pageloading = false;
        this.updateState();
      }
    });
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    this.pollsRef.off("value");
  }

  updateState = () => {
    this.setState((prev) => {
      return { ...prev };
    });
  };

  showLoading = (show) => {
    this.state.loading = show;
    this.updateState();
  };

  renderOptions = (option, index) => {
    return (
      <div className="row" key={index + ""}>
        <div className="col-sm-4">
          <div className="form-group">
            <input
              type="text"
              className="form-control"
              placeholder={ar.name}
              value={this.state.options[index].name}
              onChange={this.setOptionDetails.bind(this, "name", index)}
            />
          </div>
        </div>
        <div className="col-sm-3">
          <div className="form-group">
            <input
              type="color"
              className="form-control"
              name="color"
              placeholder={ar.color}
              value={this.state.options[index].color}
              onChange={this.setOptionDetails.bind(this, "color", index)}
            />
          </div>
        </div>
        <div className="col-sm-2">
          {this.state.poll.closed && (
            <div className="form-group">
              <input
                type="number"
                className="form-control"
                onChange={this.setOptionDetails.bind(this, "votes", index)}
                defaultValue={this.state.options[index].votes || 0}
              />
            </div>
          )}
          {!this.state.poll.closed && (
            <div className="form-group pt-2">
              {this.state.options[index].votes || 0} {ar.votes}
            </div>
          )}
        </div>
        <div className="col-sm-3 closest-rm">
          <div className="form-group">
            <button
              className="btn btn-danger"
              type="button"
              onClick={this.removeOption.bind(this, index)}
            >
              <i className="fa fa-minus"></i>
            </button>
          </div>
        </div>
      </div>
    );
  };

  setOptionDetails = (optionName, index, e) => {
    this.state.options[index][optionName] = e.target.value;
    this.updateState();
  };

  increaseOption = () => {
    this.state.options.push({
      name: "",
      votes: 0,
      color: Utils.getRandomColor(),
    });
    this.updateState();
  };

  removeOption = (index) => {
    let { options } = this.state;
    if (options.length > 2) {
      options.splice(index, 1);
      this.updateState();
    } else {
      this.showError(ar.minimum_two_options);
    }
  };

  setUpload = (e) => {
    this.state.upload = e.target.value;
    this.updateState();
  };

  saveAvatar = async (croppedImage) => {
    this.state.media = croppedImage;
    this.uploadMedia(croppedImage);
  };

  saveVideo = (video) => {
    this.state.media = video;
    this.uploadMedia(video);
  };

  uploadMedia = (media) => {
    this.showLoading(true);
    if (media) {
      firebase
        .storage()
        .ref(this.path)
        .put(media)
        .then((snapshot) => snapshot.ref.getDownloadURL())
        .then((downloadURL) =>
          this.pollsRef.update({
            image: null,
            video: null,
            [this.state.upload]: downloadURL,
          })
        )
        .then(() => {
          this.showLoading(false);
          this.showSuccess(ar.upload_successful);
        })
        .catch((error) => {
          this.showLoading(false);
          this.showError(error.message);
        });
    }
  };

  setVoteClosed = (e) => {
    this.state.poll.closed = e.target.checked;
    this.updateState();
  };

  /**
   * Saves poll details into the database
   */
  savePollDetails = () => {
    let title = this.name.value;
    let content = this.content.value;
    let closed = this.pollclosed.checked;
    if (title) {
      let { options } = this.state;
      let valid = true;
      options.forEach((option) => {
        if (!option.name) {
          valid = false;
          return;
        }
      });
      if (valid) {
        //till here poll
        this.showLoading(true);
        this.uploadDetails(title, content, options, closed)
          .then(() => {
            this.showLoading(false);
            this.showSuccess(ar.operation_successful);
          })
          .catch((error) => {
            this.showLoading(false);
            this.showError(error.message);
          });
      } else {
        this.showError(ar.please_fill_all_options);
      }
    } else {
      this.showError(ar.enter_valid_details);
    }
  };

  uploadDetails = (title, content, options, closed) => {
    let totalVotes = 0;
    options.forEach((option, index) => {
      totalVotes += parseInt(option.votes);
    });
    return this.pollsRef.update({
      title: title,
      content: content,
      options: options,
      closed: closed,
      votes: totalVotes,
    });
  };

  render() {
    let { loading, pageloading } = this.state;
    if (pageloading) {
      return null;
    }
    return (
      <div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card no-toolbar border-0">
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-9 mt-2">
                      <h2 className="card-title">{ar.egy_var}</h2>
                      <h5 className="card-subtitle">
                        {ar.enter_valid_details}
                      </h5>
                    </div>
                    <div className="col-sm-3 mt-2 text-md-left">
                      <NavLink
                        to="/var/add"
                        className="btn btn-info btn-rounded"
                      >
                        {ar.add_new}
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-8">
              <div className="card">
                <div className="card-body">
                  <div className="form-group">
                    <label
                      htmlFor="inputname"
                      className="control-label col-form-label font-weight-bold"
                    >
                      <span className="text-danger ml-1">*</span>
                      {ar.title}
                    </label>
                    <input
                      type="text"
                      ref={(e) => (this.name = e)}
                      className="form-control"
                      defaultValue={this.state.poll.title}
                      id="inputname"
                      placeholder={ar.title}
                    />
                  </div>
                  <div className="mt-5 mb-3 font-weight-bold">
                    <p>{ar.enter_description}</p>
                  </div>
                  <div id="quill-editor" className="min-h200">
                    <textarea
                      ref={(e) => (this.content = e)}
                      defaultValue={this.state.poll.content}
                      className="form-control"
                      rows={10}
                    ></textarea>
                  </div>
                  <div className="form-group mt-4">
                    <input
                      type="checkbox"
                      ref={(e) => (this.pollclosed = e)}
                      onChange={this.setVoteClosed}
                      defaultChecked={this.state.poll.closed}
                      className="custom-control-input"
                      id="poll-closed"
                      name="radio-stacked"
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="poll-closed"
                    >
                      <span className="pr-4">{ar.close_poll}</span>
                    </label>
                  </div>
                  <div className="mt-4">
                    <h4 className="card-title">{ar.select_options}</h4>
                    <div className="mt-2">
                      {this.state.options.map((option, index) =>
                        this.renderOptions(option, index)
                      )}
                    </div>
                    <div className="form-group">
                      <button
                        className="btn btn-success"
                        type="button"
                        onClick={this.increaseOption}
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </div>
                  </div>
                  <div className="button-group mt-3">
                    <button
                      type="button"
                      className="btn waves-effect waves-light btn-rounded btn-info  min-w100"
                      onClick={this.savePollDetails}
                    >
                      {ar.save}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="form-check form-check-inline">
                <div className="custom-control custom-radio">
                  <input
                    type="radio"
                    value="video"
                    onChange={this.setUpload}
                    className="custom-control-input"
                    id="customControlValidation1"
                    name="radio-stacked"
                    checked={this.state.upload === "video"}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="customControlValidation1"
                  >
                    <span className="pr-4">{ar.video}</span>
                  </label>
                </div>
                <div className="custom-control custom-radio">
                  <input
                    type="radio"
                    value="image"
                    onChange={this.setUpload}
                    className="custom-control-input"
                    id="customControlValidation2"
                    name="radio-stacked"
                    checked={this.state.upload === "image"}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="customControlValidation2"
                  >
                    <span className="pr-4">{ar.image}</span>
                  </label>
                </div>
              </div>
              <div className="mt-3">
                {this.state.upload === "video" && (
                  <VideoUploader
                    onSave={this.saveVideo}
                    videourl={this.state.poll.video}
                  />
                )}
                {this.state.upload === "image" && (
                  <PhotoUploader
                    avatar={this.state.poll.image}
                    onSaveAvatar={this.saveAvatar}
                    onlyaspectratio={true}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <Loading show={loading} />
      </div>
    );
  }
}
